package com.ustadmobile.core.view

enum class ListViewMode(val mode: String) {
    BROWSER("BROWSER"),
    PICKER("PICKER")
}

